import React from 'react'
import Skeleton from 'react-loading-skeleton'
import classnames from 'classnames/bind'

// Styles
import styles from './style.module.scss'
const cx = classnames.bind(styles)

interface HotBrandCardSkeletonProps {
  count: number
}

const HotBrandCardSkeleton = ({ count = 1 }: HotBrandCardSkeletonProps) => {
  return (
    <div className={cx('hot-brand-card-skeleton')}>
      {Array.from(Array(count)).map((_, index) => (
        <Skeleton key={index} height={160} width={122} borderRadius={10} />
      ))}
    </div>
  )
}

export default HotBrandCardSkeleton
